<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="500"
    :loading="loading"
    @close="onClose"
    @ok="onSubmit((e) => onSubmitFun(e))"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <e-input
          title="用户名"
          :validate="validateInfos.username"
          v-model:value="modelRef.username"
        />

        <e-input
          title="密码"
          :validate="validateInfos.password"
          v-model:value="modelRef.password"
          v-if="!isEdit"
          type="password"
        />

        <e-input
          title="确认密码"
          :validate="validateInfos.password_confirm"
          v-model:value="modelRef.password_confirm"
          v-if="!isEdit"
          type="password"
        />

        <e-input
          title="姓名"
          :validate="validateInfos.name"
          v-model:value="modelRef.name"
        />

        <e-input
          title="手机号"
          :validate="validateInfos.mobile"
          v-model:value="modelRef.mobile"
        />

        <e-input-upload
          title="头像"
          :validate="validateInfos.avatar"
          v-model:value="modelRef.avatar"
        />

        <e-radio
          title="性别"
          v-model:value="modelRef.sex"
          :options="$store.state.app.sexes"
        />

        <e-select
          title="角色"
          :validate="validateInfos.roleId"
          v-model:value="modelRef.roleId"
          v-if="!isEdit"
          :options="roles"
        />
      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { UserClass } from '@/apis/user'

const useForm = Form.useForm
const api = new UserClass()
export default defineComponent({
  components: {},
  mixins: [form],
  emits: ['ok'],
  props: {
    allowRoles: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const isEdit = ref(false)
    const title = ref('')

    api.modelRef.password_confirm = ''
    const modelRef = reactive(api.modelRef)

    const validatePass = async (rule, value) => {
      if (value === '') {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('请确认密码')
      } else {
        if (value !== modelRef.password) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject('两次密码不一致')
        }

        return Promise.resolve()
      }
    }

    api.rulesRef.password_confirm = [
      {
        required: true,
        validator: validatePass
      }
    ]

    const rulesRef = reactive(api.rulesRef)

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    const onClose = () => {
      resetFields()
      loading.value = false
      visible.value = false
    }

    const roles = ref([])

    return {
      title,
      visible,
      loading,
      isEdit,
      modelRef,
      validateInfos,
      roles,
      resetFields,
      validate,
      onClose
    }
  },

  methods: {
    open (formData) {
      if (formData) {
        this.modelRef.username = formData.username
        this.modelRef.mobile = formData.mobile
        this.modelRef.name = formData.name
        this.modelRef.sex = formData.sex
        this.modelRef.birthDay = formData.birthDay
        this.modelRef.avatar = formData.avatar
        this.modelRef.wechartName = formData.wechartName
        this.modelRef.wechartNum = formData.wechartNum
        this.modelRef.roleId = formData.roleIds[0]
        this.modelRef.password = '密码'
        this.modelRef.password_confirm = '密码'
        this.modelRef.id = formData.id
        this.title = '编辑：' + formData.name

        this.isEdit = true
      } else {
        this.modelRef = reactive(api.modelRef)
        this.title = '添加用户'

        this.isEdit = false
      }

      this.getRoles()

      this.visible = true
    },

    async getRoles () {
      const list =
        this.$store.state.data.ALL_ROLES.length > 0
          ? this.$store.state.data.ALL_ROLES
          : await this.$store.dispatch('GetAllRoles').then()

      const allowRoles = this.allowRoles
      const vlist = []
      if (allowRoles.length > 0) {
        list.map((e) => {
          if (allowRoles.includes(e.id)) {
            vlist.push({
              label: e.name,
              value: e.id
            })
          }
        })
      } else {
        list.map((e) => {
          vlist.push({
            label: e.name,
            value: e.id
          })
        })
      }

      this.modelRef.roleId = vlist[0].value
      this.roles = vlist
    },

    onSubmitFun (e) {
      const data = toRaw(e)

      if (this.isEdit) {
        api.update(data).then(() => {
          this.loading = false
          this.$message.success('编辑成功')
          this.$emit('ok', data)
          this.onClose()
        }).catch(e => {
          this.loading = false
        })
      } else {
        delete data.id
        api.create(data).then(() => {
          this.loading = false
          this.$message.success('添加成功')
          this.$emit('ok', data)
          this.onClose()
        }).catch(e => {
          this.loading = false
        })
      }
    }
  }
})
</script>
